/**
 * ? @description : Modal for View and Edit of Student's Data
 */

// Dependencies
import React, { useEffect, useState } from "react";
import { Button, Table } from "react-bootstrap";
import {
  Modal,
  Tooltip,
  Tab,
  Box,
  IconButton,
} from "@mui/material";
import { useDispatch } from "react-redux";

// Axios Component
import Axios from "../../../../../axios/Axios";

// Redux Component
import { showSnackbar } from "../../../../redux/features/appSlice";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Close } from "@mui/icons-material";
import axios from "axios";
import dayjs from "dayjs";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  minWidth: "800px",
  bgcolor: "background.paper",
  borderRadius: 3,
  boxShadow: 24,
  p: 4,
};
function StudentModalOpen(props) {
  // * Redux
  const dispatch = useDispatch();
  // * State Variables
  const [student, setStudent] = useState([]);
  const [buttonName, setButtonValue] = useState(false);
  const [inputValueChange, setInputValueChange] = useState(true);
  /*added by Ramanan : form Validation state variable*/
  const [dataValidate, setDataValidate] = useState({});
  const [studentLevel, setStudentLevel] = useState([]);
  const [batchData, setBatchData] = useState([]);
  const [editedStudentData, setEditedStudentData] = useState({
    student_name: "",
    whatsappno: "",
    spoken_language_2: "",
    spoken_language_3: "",
    spoken_language_4: "",
    spoken_language_5: "",
    spoken_language_6: "",
    student_age: "",
    medium_education: "",
    education: "",
    level_reading_skill: "",
    class_contactno: "",
    student_status: "",
  });

  const [tabValue, setTabValue] = useState("1");
  const [otherField, setOtherField] = useState(false);
  const [otherFieldValue, setOtherFieldValue] = useState("");
  // * Student Id
  const id = props.tabledata[0];
  // const studentId = student.student_id;
  // console.log("normal id" + id);
  // console.log("My id" + studentId);

  // * Function Call
  useEffect(() => {
    // ? Get Method : Fetch Data From Server
    const controller = axios.CancelToken.source();

    (async () => {
      if (id !== undefined) {
        try {
          let options = {
            method: "GET",
            url: `/student/${id}`,
            auth: true,
            data: null,
            token: { cancelToken: controller.token },
          };

          const response = await Axios(
            options.method,
            options.url,
            options.auth,
            options.data,
            options.token
          );

          setStudent(response.data);
        } catch (error) {
          if (!axios.isCancel(error)) {
            dispatch(
              showSnackbar({
                message: "Unable to get student data. Please try again later.",
                severity: "error",
              })
            );
          }
        }
      }
    })();
    return () => {
      controller.cancel();
    };
  }, [id, dispatch, props.show]);

  // * Assign Data to State Variable
  useEffect(() => {
    if (student.length > 0) {
      setOtherField(true);
      setEditedStudentData((prev) => ({
        ...prev,
        student_name: student[0].student_name,
        whatsappno: student[0].whatsappno,
        spoken_language_2: student[0].spoken_language_2,
        spoken_language_3: student[0].spoken_language_3,
        spoken_language_4: student[0].spoken_language_4,
        spoken_language_5: student[0].spoken_language_5,
        spoken_language_6: student[0].spoken_language_6,
        student_age: student[0].student_age,
        education: student[0].education,
        medium_education:student[0].medium_education,
        level_reading_skill: student[0].level_reading_skill,
        class_contactno: student[0].class_contactno,
        student_status: student[0].student_status,
        sponser_name: student[0].sponser_name,
        sponser_contactno: student[0].sponser_contactno,
        sponser_address: student[0].sponser_address,
      }));
      if (
        student[0].sponser_address !== "APR Villas" &&
        student[0].sponser_address !== "APR Towers"
      ) {
        setOtherFieldValue(student[0].sponser_address);
      } else {
        setOtherFieldValue("");
      }
    }
  }, [student, props.show]);

  // ? Put Method : Update Student Data in Server
  const putStudentDataById = async () => {
    setEditedStudentData({
      ...editedStudentData,
      sponser_address: otherFieldValue
        ? otherFieldValue
        : editedStudentData.sponser_address,
    });

    try {
       if (student[0].student_mapped_status === "mapped" && editedStudentData.student_status !== "active") {
              dispatch(
                showSnackbar({
                  message:"Please unmap the student and then inactivate or drop.",
                  severity: "error",
                })
              );
              return; 
            }
      let options = {
        method: "PUT",
        url: `/student/updatefields/${id}`,
        auth: true,
        data: editedStudentData,
      };

      const response = await Axios(
        options.method,
        options.url,
        options.auth,
        options.data
      );

      if (response.status === 200) {
        setButtonValue(false);
        setInputValueChange(true);
        props.onHide();
        // window.location.reload();
        setOtherField(false);
        props.onCloseCallback();
        dispatch(
          showSnackbar({
            message: "Student data updated successfully !!",
            severity: "success",
          })
        );
      } else if (response.status === 202) {
        setButtonValue(false);
        setInputValueChange(true);
        dispatch(
          showSnackbar({
            message: response.data.message,
            severity: "error",
          })
        );
      }
    } catch (error) {
      dispatch(
        showSnackbar({
          message: "Unable to update student data. Please try again later.",
          severity: "error",
        })
      );
    }
  };

  //GET Request : To fetch Student Level
  useEffect(() => {
    const controller = axios.CancelToken.source();
    (async () => {
      if (id !== undefined) {
        try {
          let options = {
            method: "POST",
            url: `/student/level/studentleveldetails`,
            auth: true,
            data: { student_id: id },
            token: { cancelToken: controller.token },
          };

          const { data, status } = await Axios(
            options.method,
            options.url,
            options.auth,
            options.data,
            options.token
          );

          if (status === 200) {
            let sortedData = data.sort((a, b) => a.level_id - b.level_id);
            setStudentLevel(sortedData);
          }
        } catch (err) {
          if (!axios.isCancel(err)) {
            console.log(err);
            dispatch(
              showSnackbar({
                message:
                  "Unable to fetch student level. Please try again later.",
                severity: "error",
              })
            );
          }
        }
      }
    })();
    return () => {
      controller.cancel();
    };
  }, [id, dispatch, props.show]);

  //GET Request : To fetch Student Batch information
  // useEffect(() => {
  // // const getStudentBatchInfo =
  // (async() => {
  //   if(id !== undefined){
  //     try{
  //       let options = {
  //         method: "GET",
  //         url: `student/map/get_mapped_teacher/${id}`,
  //         auth: true,
  //         data: null,
  //       };

  //       const {data} = await Axios(
  //         options.method,
  //         options.url,
  //         options.auth,
  //         options.data
  //       );
  //       setBatchData(data);
  //     }catch(err){
  //       dispatch(
  //         showSnackbar({
  //           message: "Unable to fetch Batch informations. Please try again later.",
  //           severity: "error",
  //         })
  //       );
  //     }
  //   }
  // })();
  // },[id]);

  //To get batchlist details for students
  useEffect(() => {
    const controller = axios.CancelToken.source();
    (async () => {
      if (id !== undefined) {
        try {
          let options = {
            method: "GET",
            url: `student/mapped/teachers/list/${id}`,
            auth: true,
            data: null,
            token: { cancelToken: controller.token },
          };

          let { data, status } = await Axios(
            options.method,
            options.url,
            options.auth,
            options.data,
            options.token
          );

          console.log(data);
          if (status === 200 && data.length > 0) {
            setBatchData(data);
          } else {
            setBatchData([]);
          }
        } catch (error) {
          if (!axios.isCancel(error)) {
            console.log(error);
            dispatch(
              showSnackbar({
                message:
                  "Unable to get batch list information for this student.",
                severity: "error",
              })
            );
          }
        }
      }
    })();
    return () => {
      controller.cancel();
    };
  }, [id, dispatch, props.show]);

  const registerDate = dayjs(student[0]?.screated_at).format("DD-MM-YYYY");

  console.log(editedStudentData, "editedStudentData");
  console.log(student, "student");

  return (
    student.length > 0 && (
      <Modal open={props.show} onClose={props.onHide}>
        <Box sx={style}>
          <TabContext value={tabValue}>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <h5>
                Student Information&nbsp;
                <Tooltip
                  title="Edit Student Information"
                  arrow
                  placement="bottom"
                >
                  <span
                    data-bs-toggle="tooltip"
                    data-bs-placement="right"
                    onClick={() => {
                      setButtonValue(!buttonName);
                      setInputValueChange(!inputValueChange);
                    }}
                  >
                    <i class="bi bi-pencil-fill"></i>
                  </span>
                </Tooltip>
              </h5>
            </Box>
            <Box
              sx={{
                borderBottom: 1,
                borderColor: "divider",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <TabList
                value={tabValue}
                onChange={(e, newValue) => setTabValue(newValue)}
              >
                <Tab label="Primary" value="1" />
                <Tab label="Mapped Info" value="2" />
                <Tab label="Sponsor" value="3" />
                <Tab label="Level" value="4" />
              </TabList>
              <IconButton
                onClick={() => {
                  props.onHide();
                  setInputValueChange(true);
                  setButtonValue(false);
                  setOtherField(false);
                }}
              >
                <Close />
              </IconButton>
            </Box>
            <TabPanel value="1">
              <div className="d-flex justify-content-start">
                <div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "2px",
                    }}
                  >
                    <p style={{ width: "160px" }}>Name&nbsp;:</p>
                    <input
                      style={{
                        paddingLeft: "5px",
                        textTransform: "capitalize",
                      }}
                      type="text"
                      value={editedStudentData.student_name}
                      onChange={(e) => {
                        e.target.value.length === 0
                          ? setDataValidate((prevData) => {
                              return { ...prevData, isNameError: true };
                            })
                          : setDataValidate((prevData) => {
                              return { ...prevData, isNameError: false };
                            });
                        setEditedStudentData({
                          ...editedStudentData,
                          student_name: e.target.value,
                        });
                      }}
                      disabled={inputValueChange}
                    />
                  </div>
                  <p style={{ color: "red" }}>
                    {dataValidate.isNameError && "Enter a valid name"}
                  </p>
                  <br />

                  <div style={{ display: "flex", alignItems: "center" }}>
                    <p style={{ width: "160px" }}>WhatsApp Number&nbsp;:</p>
                    <input
                      style={{ paddingLeft: "5px" }}
                      type="text"
                      value={editedStudentData.whatsappno}
                      onChange={(e) => {
                        e.target.value.length !== 10
                          ? setDataValidate((prevData) => {
                              return { ...prevData, isWhatsappError: true };
                            })
                          : setDataValidate((prevData) => {
                              return { ...prevData, isWhatsappError: false };
                            });
                        setEditedStudentData({
                          ...editedStudentData,
                          whatsappno: e.target.value,
                        });
                      }}
                      disabled={inputValueChange}
                    />
                  </div>
                  <p style={{ color: "red" }}>
                    {dataValidate.isWhatsappError &&
                      "Whatsapp number must contain 10 digits"}
                  </p>
                  <br />

                  <div style={{ display: "flex", alignItems: "center" }}>
                    <p style={{ width: "160px" }}>Contact Number&nbsp;:</p>
                    <input
                      style={{ paddingLeft: "5px" }}
                      type="text"
                      value={editedStudentData.class_contactno}
                      onChange={(e) => {
                        e.target.value.length !== 10
                          ? setDataValidate((prevData) => {
                              return { ...prevData, isContactError: true };
                            })
                          : setDataValidate((prevData) => {
                              return { ...prevData, isContactError: false };
                            });
                        setEditedStudentData({
                          ...editedStudentData,
                          class_contactno: e.target.value,
                        });
                      }}
                      disabled={inputValueChange}
                    />
                  </div>
                  <p style={{ color: "red" }}>
                    {dataValidate.isContactError &&
                      "Contact number must contain 10 digits"}
                  </p>
                  <br />
                  <div style={{ display: "flex", gap: "20px" }}>
                    <p style={{ width: "160px" }}>Status&nbsp;:</p>

                    <select
                      style={{ width: "60%" }}
                      disabled={inputValueChange}
                      value={editedStudentData.student_status}
                      onChange={(e) =>
                        setEditedStudentData({
                          ...editedStudentData,
                          student_status: e.target.value,
                        })
                      }
                    >
                      <option value="active">Active</option>
                      <option value="inactive">In-active</option>
                      <option value="deleted">Drop</option>
                    </select>
                  </div>
                  <br />

                  <div style={{ display: "flex", width: "250px", gap: "20px" }}>
                    <p style={{ width: "160px" }}>Role&nbsp;:</p>
                    <p>
                      <strong>{student[0].role}</strong>
                    </p>
                  </div>
                  <br />
                  <div style={{ display: "flex", width: "280px", gap: "20px" }}>
                    <p style={{ width: "160px" }}>Mapped Status&nbsp;:</p>
                    <p>
                      <strong>{student[0].student_mapped_status}</strong>
                    </p>
                  </div>
                  <br />
                </div>

                <div className="mx-3">
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <p style={{ width: "130px" }}>Language 1&nbsp;:</p>
                    <input
                      style={{ paddingLeft: "5px" }}
                      type="text"
                      value={student[0].spoken_language_1}
                      disabled
                    />
                  </div>
                  <br />
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <p style={{ width: "130px" }}>Language 2&nbsp;:</p>
                    <input
                      style={{ paddingLeft: "5px" }}
                      type="text"
                      value={editedStudentData.spoken_language_2}
                      onChange={(e) =>
                        setEditedStudentData({
                          ...editedStudentData,
                          spoken_language_2: e.target.value,
                        })
                      }
                      disabled={inputValueChange}
                    />
                  </div>
                  <br />
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <p style={{ width: "130px" }}>Language 3&nbsp;:</p>
                    <input
                      style={{ paddingLeft: "5px" }}
                      type="text"
                      value={editedStudentData.spoken_language_3}
                      onChange={(e) =>
                        setEditedStudentData({
                          ...editedStudentData,
                          spoken_language_3: e.target.value,
                        })
                      }
                      disabled={inputValueChange}
                    />
                  </div>
                  <br />
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <p style={{ width: "130px" }}>Language 4&nbsp;:</p>
                    <input
                      style={{ paddingLeft: "5px" }}
                      type="text"
                      value={editedStudentData.spoken_language_4}
                      onChange={(e) =>
                        setEditedStudentData({
                          ...editedStudentData,
                          spoken_language_4: e.target.value,
                        })
                      }
                      disabled={inputValueChange}
                    />
                  </div>
                  <br />
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <p style={{ width: "130px" }}>Language 5&nbsp;:</p>
                    <input
                      style={{ paddingLeft: "5px" }}
                      type="text"
                      value={editedStudentData.spoken_language_5}
                      onChange={(e) =>
                        setEditedStudentData({
                          ...editedStudentData,
                          spoken_language_5: e.target.value,
                        })
                      }
                      disabled={inputValueChange}
                    />
                  </div>
                  <br />
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <p style={{ width: "130px" }}>Language 6&nbsp;:</p>
                    <input
                      style={{ paddingLeft: "5px" }}
                      type="text"
                      value={editedStudentData.spoken_language_6}
                      onChange={(e) =>
                        setEditedStudentData({
                          ...editedStudentData,
                          spoken_language_6: e.target.value,
                        })
                      }
                      disabled={inputValueChange}
                    />
                  </div>
                </div>
                <div>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <p style={{ width: "150px" }}>Age&nbsp;:</p>
                    <input
                      style={{ paddingLeft: "5px" }}
                      type="text"
                      value={editedStudentData.student_age}
                      onChange={(e) =>
                        setEditedStudentData({
                          ...editedStudentData,
                          student_age: e.target.value,
                        })
                      }
                      disabled={inputValueChange}
                    />
                  </div>
                  <br />
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <p style={{ width: "150px" }}>Medium of education&nbsp;:</p>
                    <input
                      style={{ paddingLeft: "5px" }}
                      type="text"
                      value={editedStudentData.medium_education}
                      onChange={(e) => {
                        e.target.value.length === 0
                          ? setDataValidate((prevData) => {
                              return { ...prevData, isEducationError: true };
                            })
                          : setDataValidate((prevData) => {
                              return { ...prevData, isEducationError: false };
                            });
                        setEditedStudentData({
                          ...editedStudentData,
                          medium_education: e.target.value,
                        });
                      }}
                      disabled={inputValueChange}
                    />
                  </div>
                  <p style={{ color: "red" }}>
                    {dataValidate.isEducationError &&
                      "Please Enter a valid Education"}
                  </p>
                  <br />

                  <div style={{ display: "flex", alignItems: "center" }}>
                    <p style={{ width: "150px" }}>
                      Highest level of education&nbsp;:
                    </p>
                    <input
                      style={{ paddingLeft: "5px" }}
                      type="text"
                      value={editedStudentData.education}
                      onChange={(e) => {
                        e.target.value.length < 5
                          ? setDataValidate((prevData) => {
                              return { ...prevData, isReadingSkillError: true };
                            })
                          : setDataValidate((prevData) => {
                              return {
                                ...prevData,
                                isReadingSkillError: false,
                              };
                            });
                        setEditedStudentData({
                          ...editedStudentData,
                          education: e.target.value,
                        });
                      }}
                      disabled={inputValueChange}
                    />
                  </div>
                  <p style={{ color: "red" }}>
                    {dataValidate.isReadingSkillError &&
                      "Please Enter a valid skill"}
                  </p>
                  <br />

                  <div style={{ display: "flex", alignItems: "center" }}>
                    <p style={{ width: "150px" }}>Registered Date&nbsp;:</p>
                    <input
                      style={{ paddingLeft: "5px" }}
                      type="text"
                      value={registerDate}
                      disabled
                    />
                  </div>
                  <br />
                </div>
              </div>
            </TabPanel>
            <TabPanel value="2">
              <div className="d-flex flex-column">
                <div>
                  {batchData.length > 0 ? (
                    <Table striped bordered hover>
                      <thead>
                        <tr>
                          {/* <th>Teacher Id</th> */}
                          <th>Teacher Name</th>
                        </tr>
                      </thead>
                      <tbody>
                        {batchData.map((data, index) => {
                          return (
                            <tr key={index}>
                              {/* <td><strong>{data.teacher_id}</strong></td> */}
                              <td>{data.teacher_name}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                  ) : (
                    <p
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        color: "red",
                      }}
                    >
                      There is no mapping information for this student
                    </p>
                  )}
                </div>
              </div>
            </TabPanel>
            <TabPanel value="3">
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "4.1px",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <p style={{ width: "150px" }}>Sponsor Name&nbsp;:</p>
                  <input
                    style={{ paddingLeft: "5px" }}
                    type="text"
                    value={editedStudentData.sponser_name}
                    onChange={(e) => {
                      e.target.value.length < 1
                        ? setDataValidate((prevData) => {
                            return { ...prevData, isSponsorNameError: true };
                          })
                        : setDataValidate((prevData) => {
                            return { ...prevData, isSponsorNameError: false };
                          });
                      setEditedStudentData({
                        ...editedStudentData,
                        sponser_name: e.target.value,
                      });
                    }}
                    disabled={inputValueChange}
                  />
                </div>
                <p style={{ color: "red" }}>
                  {dataValidate.isSponsorNameError &&
                    "Please Enter a valid Sponsor"}
                </p>
                <br />

                <div style={{ display: "flex", alignItems: "center" }}>
                  <p style={{ width: "150px" }}>Sponsor Number&nbsp;:</p>
                  <input
                    style={{ paddingLeft: "5px" }}
                    type="text"
                    value={editedStudentData.sponser_contactno}
                    onChange={(e) => {
                      e.target.value.length !== 10
                        ? setDataValidate((prevData) => {
                            return { ...prevData, isSponsorContactError: true };
                          })
                        : setDataValidate((prevData) => {
                            return {
                              ...prevData,
                              isSponsorContactError: false,
                            };
                          });
                      setEditedStudentData({
                        ...editedStudentData,
                        sponser_contactno: e.target.value,
                      });
                    }}
                    disabled={inputValueChange}
                  />
                </div>
                <p style={{ color: "red" }}>
                  {dataValidate.isSponsorContactError &&
                    "Sponsor Contact number must contain 10 digits"}
                </p>
                <br />

                <div style={{ display: "flex", alignItems: "center" }}>
                  <p style={{ width: "150px" }}>Sponsor Address&nbsp;:</p>

                  <select
                    disabled={inputValueChange}
                    value={
                      editedStudentData.sponser_address !== "APR Villas" &&
                      editedStudentData.sponser_address !== "APR Towers"
                        ? "others"
                        : editedStudentData.sponser_address
                    }
                    // value ={editedStudentData.sponser_address}
                    onChange={(e) => {
                      if (e.target.value === "others") {
                        setEditedStudentData({
                          ...editedStudentData,
                          sponser_address: e.target.value,
                        });
                        setOtherField(true);
                      } else {
                        setOtherFieldValue("");
                        setOtherField(false);
                      }
                      setEditedStudentData({
                        ...editedStudentData,
                        sponser_address: e.target.value,
                      });
                    }}
                  >
                    <option value="APR Villas">APR Villas</option>
                    <option value="APR Towers">APR Towers</option>
                    <option value="others">Others</option>
                  </select>
                  {otherField &&
                    editedStudentData.sponser_address !== "APR Villas" &&
                    editedStudentData.sponser_address !== "APR Towers" && (
                      <input
                        style={{ paddingRight: "5px", marginLeft: "5px" }}
                        type="text"
                        value={otherFieldValue}
                        onChange={(e) => {
                          // e.target.value.length !== 10 ? setDataValidate(prevData => { return { ...prevData, isSponsorContactError: true } })
                          //   : setDataValidate(prevData => { return { ...prevData, isSponsorContactError: false } })
                          // setEditedStudentData({
                          //   ...editedStudentData,
                          //   sponser_contactno: e.target.value,
                          // })
                          setEditedStudentData({
                            ...editedStudentData,
                            sponser_address: e.target.value,
                          });
                          setOtherFieldValue(e.target.value);
                        }}
                        disabled={inputValueChange}
                      />
                    )}
                </div>
              </div>
            </TabPanel>
            <TabPanel value="4">
              {studentLevel.length > 0 ? (
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>Level</th>
                      <th>Level Status</th>
                      <th>Audio Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {studentLevel.map((level) => {
                      return (
                        <tr>
                          <td>
                            <strong>{level.level_name}</strong>
                          </td>
                          <td>
                            {!!level.level_status
                              ? level.level_status
                              : "No level assigned"}
                          </td>
                          <td>{level.audio_status}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              ) : (
                <p
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    color: "red",
                  }}
                >
                  There is no level information for this student
                </p>
              )}
            </TabPanel>
            <Box
              sx={{
                borderTop: 1,
                borderColor: "divider",
                display: "flex",
                alignItems: "center",
              }}
            >
              {buttonName === false ? (
                <Button
                  style={{ marginTop: "1rem" }}
                  variant="primary"
                  onClick={() => {
                    setOtherField(false);
                    props.onHide();
                  }}
                >
                  CLOSE
                </Button>
              ) : (
                <div>
                  <Button
                    style={{ marginTop: "1rem" }}
                    type="button"
                    variant="light"
                    onClick={() => {
                      setButtonValue(false);
                      setInputValueChange(true);
                      props.onHide();
                      setOtherField(false);
                    }}
                  >
                    CANCEL
                  </Button>
                  <Button
                    style={{ marginTop: "1rem" }}
                    type="submit"
                    variant="primary"
                    onClick={() => putStudentDataById()}
                    disabled={
                      !Object.keys(dataValidate).every(
                        (error) => dataValidate[error] === false
                      )
                    }
                  >
                    SAVE
                  </Button>
                </div>
              )}
            </Box>
          </TabContext>
        </Box>
      </Modal>
    )
  );
}

export default StudentModalOpen;

//{
  /* <Modal
{...props}
size="xl"
aria-labelledby="contained-modal-title-vcenter"
centered
>
<Modal.Header>
  <Modal.Title id="contained-modal-title-vcenter">
    <h5>
      Student Information&nbsp;
      <Tooltip
        title="Edit Student Information"
        arrow
        placement="bottom"
      >
        <span
          data-bs-toggle="tooltip"
          data-bs-placement="right"
          onClick={() => {
            setButtonValue(true);
            setInputValueChange(false);
          }}
        >
          <i class="bi bi-pencil-fill"></i>
        </span>
      </Tooltip>
    </h5>
  </Modal.Title>
</Modal.Header>

<Modal.Body>
  <Tabs
    className="mb-3"
    id="uncontrolled-tab-example"
    defaultActiveKey="primary"
  >
    <Tab eventKey="primary" title="Primary">
      <div className="d-flex justify-content-start">
        <div>
          {/* <div style={{ display: "flex", alignItems: "center" }}>
            <p style={{ width: "160px" }}>Unique Id&nbsp;:</p>
            <input type="text" value={student[0].student_id} disabled />
          </div>---

          {/* <br />---

          <div style={{ display: "flex", alignItems: "center" }}>
            <p style={{ width: "160px" }}>Name&nbsp;:</p>
            <input
            style={{paddingLeft: '5px'}}
              type="text"
              value={editedStudentData.student_name}
              onChange={(e) => {
                  e.target.value.length === 0 ? setDataValidate(prevData => {
                    return {...prevData, isNameError : true}
                  }) : setDataValidate(prevData => {
                    return {...prevData, isNameError : false}
                  })
                  setEditedStudentData({
                    ...editedStudentData,
                    student_name: e.target.value,
                  })
                }
              }
              disabled={inputValueChange}
            />
          </div>
          <p style={{color : "red"}}>{dataValidate.isNameError && "Enter a valid name"}</p>
          <br />

          <div style={{ display: "flex", alignItems: "center" }}>
            <p style={{ width: "160px" }}>WhatsApp Number&nbsp;:</p>
            <input
            style={{paddingLeft: '5px'}}
              type="text"
              value={editedStudentData.whatsappno}
              onChange={(e) =>{
                  e.target.value.length !== 10 ? setDataValidate(prevData => {return {...prevData, isWhatsappError : true}})
                   : setDataValidate(prevData => {return {...prevData, isWhatsappError : false}})
                  setEditedStudentData({
                    ...editedStudentData,
                    whatsappno: e.target.value,
                  })
                }
              }
              disabled={inputValueChange}
            />
            
          </div>
          <p style={{color : "red"}}>{dataValidate.isWhatsappError && "Whatsapp number must contain 10 digits"}</p>
          <br />

          <div style={{ display: "flex", alignItems: "center" }}>
            <p style={{ width: "160px" }}>Contact Number&nbsp;:</p>
            <input
            style={{paddingLeft: '5px'}}
              type="text"
              value={editedStudentData.class_contactno}
              onChange={(e) => {
                  e.target.value.length !== 10 ? setDataValidate(prevData => {return {...prevData, isContactError : true}})
                   : setDataValidate(prevData => {return {...prevData, isContactError : false}})
                  setEditedStudentData({
                    ...editedStudentData,
                    class_contactno: e.target.value,
                  })
                }
              }
              disabled={inputValueChange}
            />
          </div>
          <p style={{color : "red"}}>{dataValidate.isContactError && "Contact number must contain 10 digits"}</p>
          <br />
          <div style={{ display: "flex", gap: "20px"}}>
            <p style={{ width: "160px" }}>Status&nbsp;:</p>

            <select style={{width: "60%"}} disabled={inputValueChange}
              value={editedStudentData.student_status}
              onChange={(e) => setEditedStudentData({
                ...editedStudentData,
                student_status : e.target.value
              })}
            >
              <option value="active">Active</option>
              <option value="inactive">In-active</option>
            </select>
          </div>
          <br />
          
          <div style={{ display: "flex", width: "250px", gap: "20px"}}>
            <p style={{ width: "160px" }}>Role&nbsp;:</p>
            <p>
              <strong>{student[0].role}</strong>
            </p>
          </div>
          <br />

          {/* <div style={{ display: "flex", width: "280px", gap: "20px"}}>
            <p style={{ width: "160px" }}>Group Status&nbsp;:</p>
            <p>
              <strong>{student[0].group_status}</strong>
            </p>
          </div> ---
          

          <div style={{ display: "flex", width: "280px", gap: "20px"}}>
            <p style={{ width: "160px" }}>Mapped Status&nbsp;:</p>
            <p>
              <strong>{student[0].student_mapped_status}</strong>
            </p>
          </div>
          <br />
        </div>

        <div className="mx-3">
          <div style={{ display: "flex", alignItems: "center" }}>
            <p style={{ width: "130px" }}>Language 1&nbsp;:</p>
            <input
            style={{paddingLeft: '5px'}}
              type="text"
              value={student[0].spoken_language_1}
              disabled
            />
          </div>

          <br />

          <div style={{ display: "flex", alignItems: "center" }}>
            <p style={{ width: "130px" }}>Language 2&nbsp;:</p>
            <input
            style={{paddingLeft: '5px'}}
              type="text"
              value={editedStudentData.spoken_language_2}
              onChange={(e) =>
                setEditedStudentData({
                  ...editedStudentData,
                  spoken_language_2: e.target.value,
                })
              }
              disabled={inputValueChange}
            />
          </div>

          <br />

          <div style={{ display: "flex", alignItems: "center" }}>
            <p style={{ width: "130px" }}>Language 3&nbsp;:</p>
            <input
            style={{paddingLeft: '5px'}}
              type="text"
              value={editedStudentData.spoken_language_3}
              onChange={(e) =>
                setEditedStudentData({
                  ...editedStudentData,
                  spoken_language_3: e.target.value,
                })
              }
              disabled={inputValueChange}
            />
          </div>

          <br />

          <div style={{ display: "flex", alignItems: "center" }}>
            <p style={{ width: "130px" }}>Language 4&nbsp;:</p>
            <input
            style={{paddingLeft: '5px'}}
              type="text"
              value={editedStudentData.spoken_language_4}
              onChange={(e) =>
                setEditedStudentData({
                  ...editedStudentData,
                  spoken_language_4: e.target.value,
                })
              }
              disabled={inputValueChange}
            />
          </div>

          <br />

          <div style={{ display: "flex", alignItems: "center" }}>
            <p style={{ width: "130px" }}>Language 5&nbsp;:</p>
            <input
            style={{paddingLeft: '5px'}}
              type="text"
              value={editedStudentData.spoken_language_5}
              onChange={(e) =>
                setEditedStudentData({
                  ...editedStudentData,
                  spoken_language_5: e.target.value,
                })
              }
              disabled={inputValueChange}
            />
          </div>

          <br />

          <div style={{ display: "flex", alignItems: "center" }}>
            <p style={{ width: "130px" }}>Language 6&nbsp;:</p>
            <input
            style={{paddingLeft: '5px'}}
              type="text"
              value={editedStudentData.spoken_language_6}
              onChange={(e) =>
                setEditedStudentData({
                  ...editedStudentData,
                  spoken_language_6: e.target.value,
                })
              }
              disabled={inputValueChange}
            />
          </div>
        </div>

        <div>
          <div style={{ display: "flex", alignItems: "center" }}>
            <p style={{ width: "150px" }}>Age&nbsp;:</p>
            <input
            style={{paddingLeft: '5px'}}
              type="text"
              value={editedStudentData.student_age}
              onChange={(e) =>
                setEditedStudentData({
                  ...editedStudentData,
                  student_age: e.target.value,
                })
              }
              disabled={inputValueChange}
            />
          </div>

          <br />

          <div style={{ display: "flex", alignItems: "center" }}>
            <p style={{ width: "150px" }}>Education&nbsp;:</p>
            <input
            style={{paddingLeft: '5px'}}
              type="text"
              value={editedStudentData.education}
              onChange={(e) =>{
                e.target.value.length === 0 ? setDataValidate(prevData => {
                  return {...prevData, isEducationError : true}
                }) : setDataValidate(prevData => {
                  return {...prevData, isEducationError : false}
                })
                setEditedStudentData({
                  ...editedStudentData,
                  education: e.target.value,
                })}
              }
              disabled={inputValueChange}
            />
          </div>
          <p style={{color : "red"}}>{dataValidate.isEducationError && "Please Enter a valid Education"}</p>
          <br />

          <div style={{ display: "flex", alignItems: "center" }}>
            <p style={{ width: "150px" }}>Reading Skill&nbsp;:</p>
            <input
            style={{paddingLeft: '5px'}}
              type="text"
              value={editedStudentData.level_reading_skill}
              onChange={(e) => {
                e.target.value.length < 5 ? setDataValidate(prevData => {
                  return {...prevData, isReadingSkillError : true}
                }) : setDataValidate(prevData => {
                  return {...prevData, isReadingSkillError : false}
                })
                setEditedStudentData({
                  ...editedStudentData,
                  level_reading_skill: e.target.value,
                })}
              }
              disabled={inputValueChange}
            />
          </div>
          <p style={{color : "red"}}>{dataValidate.isReadingSkillError && "Please Enter a valid skill"}</p>
          <br />

          <div style={{ display: "flex", alignItems: "center" }}>
            <p style={{ width: "150px" }}>Registered Date&nbsp;:</p>
            <input
            style={{paddingLeft: '5px'}}
              type="text"
              value={student[0].screated_at.split("T")[0]}
              disabled
            />
          </div>
          <br />


         
          {/* <br /> ---
        </div>
      </div>
    </Tab>

    <Tab eventKey="other" title="Mapped info">
      <div className="d-flex flex-column">
        <div>
          {batchData.length > 0 ? 
            <Table striped bordered hover>
              <thead>
                <tr>
                  {/* <th>Teacher Id</th>---
                  <th>Teacher Name</th>
                </tr>
              </thead>
              <tbody>
                {batchData.map((data, index) => {
                  return(
                    <tr key={index}>
                      {/* <td><strong>{data.teacher_id}</strong></td>---
                      <td>{data.teacher_name}</td>
                    </tr>
                  )
                })}
              </tbody>
            </Table> : 
            <p style={{display : "flex", justifyContent: "center", color: "red"}}>There is no mapping information for this student</p>
          }
        </div>
      </div>
    </Tab>
    
    <Tab eventKey="sponsor" title="Sponsor">
      <div>
        <div style={{ display: "flex", alignItems: "center" }}>
          <p style={{ width: "150px" }}>Sponsor Name&nbsp;:</p>
          {/* <p>
            <strong>{student[0].sponser_name}</strong>
          </p> ---
          <input
          style={{paddingLeft: '5px'}}
            type="text"
            value={editedStudentData.sponser_name}
            onChange={(e) => {
              e.target.value.length < 1 ? setDataValidate(prevData => {
                return {...prevData, isSponsorNameError : true}
              }) : setDataValidate(prevData => {
                return {...prevData, isSponsorNameError : false}
              })
              setEditedStudentData({
                ...editedStudentData,
                sponser_name: e.target.value,
              })}
            }
            disabled={inputValueChange}
          />
        </div>
        <p style={{color : "red"}}>{dataValidate.isSponsorNameError && "Please Enter a valid Sponsor"}</p>
        <br />

        <div style={{ display: "flex", alignItems: "center" }}>
          <p style={{ width: "150px" }}>Sponsor Number&nbsp;:</p>
          {/* <p>
            <strong>{student[0].sponser_contactno}</strong>
          </p> --

          <input
          style={{paddingLeft: '5px'}}
            type="text"
            value={editedStudentData.sponser_contactno}
            onChange={(e) => {
              e.target.value.length !== 10 ? setDataValidate(prevData => {return {...prevData, isSponsorContactError : true}})
                   : setDataValidate(prevData => {return {...prevData, isSponsorContactError : false}})
              setEditedStudentData({
                ...editedStudentData,
                sponser_contactno: e.target.value,
              })}
            }
            disabled={inputValueChange}
          />
        </div>
        <p style={{color : "red"}}>{dataValidate.isSponsorContactError && "Sponsor Contact number must contain 10 digits"}</p>
        <br />

        <div style={{ display: "flex", alignItems: "center" }}>
          <p style={{ width: "150px" }}>Sponsor Address&nbsp;:</p>
          {/* <p>
            <strong>{student[0].sponser_address}</strong>
          </p> ---
          <select 
            disabled={inputValueChange}
            value={editedStudentData.sponser_address}
            onChange={(e) => setEditedStudentData({
              ...editedStudentData,
              sponser_address: e.target.value,
            })}
            >
              <option value="APR Villas">APR Villas</option>
              <option value="APR Towers">APR Towers</option>
              <option value="others">Others</option>
          </select> 
        </div> 
        {/* <p style={{color : "red"}}>{dataValidate.isSponsorAddressError && "Please Enter a valid Sponsor Address"}</p> ---
      </div>
    </Tab>
    <Tab eventKey="student-level" title="Level">
      {studentLevel.length > 0 ? 
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Level</th>
              <th>Level Status</th>
              <th>Audio Status</th>
            </tr>
          </thead>
          <tbody>
            {studentLevel.map(level => {
              return(
                <tr>
                  <td><strong>{level.level_name}</strong></td>
                  <td>{!!level.level_status ? level.level_status : "No level assigned"}</td>
                  <td>{level.audio_status}</td>
                </tr>
              )
            })}
          </tbody>
        </Table> :
        <p style={{display : "flex", justifyContent: "center", color: "red"}}>There is no level information for this student</p>
      }
    </Tab>
  </Tabs>
</Modal.Body>

<Modal.Footer>
  {buttonName === false ? (
    <Button variant="primary" onClick={props.onHide}>
      CLOSE
    </Button>
  ) : (
    <div>
      <Button
        type="button"
        variant="light"
        onClick={() => {
          setButtonValue(false);
          setInputValueChange(true);
          props.onHide();
        }}
      >
        CANCEL
      </Button>
      <Button
        type="submit"
        variant="primary"
        onClick={() => putStudentDataById()}
        disabled={!Object.keys(dataValidate).every(error => dataValidate[error] === false)}
      >
        SAVE
      </Button>
    </div>
  )}
</Modal.Footer>
</Modal> */
//}
